//

import SelectField from 'modules/v2/common/components/SelectField';
import { getCurrentTimeZone, getTZDataTimeZonesList } from 'modules/v2/common/utils/timezone';

import S from './styles';

const TimeZoneDropDown = ({ onChange, defaultValue = getCurrentTimeZone }) => (
  <S.SelectFieldWrap>
    <SelectField
      defaultValue={defaultValue}
      options={getTZDataTimeZonesList()}
      onChange={onChange}
      showSearch
    />
  </S.SelectFieldWrap>
);

export default TimeZoneDropDown;
